import Router from './Router'
import { AuthContextProvider } from '@sharpana/auth/AuthContext';
import GlobalModals from '@sharpana/ui/GlobalModals';

function App() {
  return (
    <AuthContextProvider>
      <Router />
      <GlobalModals />
    </AuthContextProvider>
  );
}

export default App;
